import React from 'react';
import { ArrowRight, CheckCircle2, Phone, Star } from 'lucide-react';
import { QuoteForm } from './QuoteForm';
import { PHONE_DISPLAY, PHONE_HREF } from '../data/site';
import { reviews } from '../data/reviews';
export interface IntroData {
  title: string;
  highlight?: string;
  badge?: string;
  intro: string;
  bullets: readonly string[];
  service: string;
}
export function PageIntro({
  data,
  id,
  urgent = false
}: {
  data: IntroData;
  id: string;
  urgent?: boolean;
}) {
  const [before, after] = data.highlight ? data.title.split(data.highlight) : [data.title, ''];
  return <section className="border-b border-kosin-line bg-kosin-mist" data-id="element-252" data-mp="3hwvn9a72lpq2">
      <div className="page-shell py-7 lg:py-10" data-id="element-253" data-mp="3hwlujeun54go">
        <nav aria-label="Breadcrumb" className="mb-6 flex flex-wrap items-center gap-2 text-[13px] text-kosin-body" data-id="element-254" data-mp="3mvgn38ieu7dz">
          <a href="/" className="hover:text-kosin-red" data-id="element-255" data-mp="26gouauhcqy45">Home</a><span aria-hidden="true" data-id="element-256" data-mp="26k2vw0i6z3aj">/</span><span data-id="element-257" data-mp="2bhckxf1o5cxu">{data.service || 'Glass Services'}</span>
        </nav>
        <div className="service-hero-grid" data-id="element-258" data-mp="2begnrsxnasag">
          <div className="contents min-[640px]:block" data-id="element-259" data-mp="18vxam86zu8er">
            <div className="order-1" data-id="element-260" data-mp="13vsu4i635doj">
              {data.badge && <p className="mb-4 text-[14px] font-semibold text-kosin-red" data-id="element-261" data-mp="13x2tdaoocrwr">{data.badge}</p>}
              <h1 className="text-[32px] font-bold leading-[1.12] text-kosin-charcoal sm:text-[40px] xl:text-[46px]" data-id="element-262" data-mp="1iu3fmyo3junu">
                {before}{data.highlight && <span className="text-kosin-red" data-id="element-263" data-mp="1dwbldxzzbwgh">{data.highlight}</span>}{after}
              </h1>
            </div>
            <div className="order-3 mt-6" data-id="element-264" data-mp="1mux01i2byrbz">
              <p className="max-w-2xl text-[17px] leading-relaxed text-kosin-body sm:text-[18px]" data-id="element-265" data-mp="1mtvpdep886us">{data.intro}</p>
              <ul className="mt-6 space-y-3" data-id="element-266" data-mp="21irtj0o5wzq4">
                {data.bullets.map(item => <li key={item} className="flex gap-3 text-[15px] leading-relaxed sm:text-[16px]" data-id="element-267" data-mp="1wlhx312cvnss"><CheckCircle2 className="mt-1 h-5 w-5 shrink-0 text-kosin-red" aria-hidden="true" data-id="element-268" data-mp="2ajq11sxt7pdg" /><span data-id="element-269" data-mp="26iwccxcjm6ji">{item}</span></li>)}
              </ul>
              <a href={PHONE_HREF} className="mt-6 inline-flex min-h-11 items-center gap-2 text-[16px] font-semibold text-kosin-charcoal hover:text-kosin-red" data-id="element-270" data-mp="26kh8grei9xjh"><Phone className="h-4 w-4 text-kosin-red" aria-hidden="true" data-id="element-271" data-mp="2iknuzliyf6gb" />{urgent ? 'Call Now:' : 'Prefer To Call?'} {PHONE_DISPLAY}</a>
              {urgent && <p className="mt-3 max-w-xl border-l-2 border-kosin-red pl-4 text-[14px] leading-relaxed text-kosin-body" data-id="element-272" data-mp="2nifkk8w4mghc">If visibility is blocked or glass is loose, do not continue driving. Call to discuss the safest next step.</p>}
            </div>
          </div>
          <div id="quote" className="order-2 mt-1 box-border w-full min-w-0 min-[640px]:mt-0" data-id="element-273" data-mp="31am4m62eh7m2">
            <QuoteForm key={id} idPrefix={id} initialService={data.service} data-id="element-274" data-mp="369ymsdibtqib" />
          </div>
        </div>
      </div>
    </section>;
}
export function ServiceReview({
  index
}: {
  index: number;
}) {
  const review = reviews[index];
  return <section className="border-y border-kosin-line bg-kosin-mist" data-id="element-275" data-mp="1by1u6h85eelo"><figure className="page-shell py-10 text-center" data-id="element-276" data-mp="1gv22yzwdtvgh">
    <div className="mb-4 flex justify-center gap-1 text-[#b67700]" aria-label="Five-star customer review" data-id="element-277" data-mp="1gxo7eqnz7uuh">{[1, 2, 3, 4, 5].map(n => <Star key={n} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-278" data-mp="3pf4xo8d8stys" />)}</div>
    <blockquote className="mx-auto max-w-3xl text-[20px] font-medium leading-relaxed text-kosin-charcoal" data-id="element-279" data-mp="3pd0k0ypjkglb">&ldquo;{review.quote}&rdquo;</blockquote>
    <figcaption className="mt-4 text-[14px] text-kosin-body" data-id="element-280" data-mp="3gf83jr8332wc">{review.name}<a href={review.sourceUrl} className="ml-3 inline-flex items-center gap-1 underline underline-offset-4" data-id="element-281" data-mp="gzbe1knm72di">Google Review<ArrowRight className="h-3 w-3" aria-hidden="true" data-id="element-282" data-mp="cx6ph0c0wvxq" /></a></figcaption>
  </figure></section>;
}